import { SESSION_STATUS_KEY } from './validateSDEventsByPage';

// These utils functions must be exported from web-analytics-bundle, remove them when it's done.
const optanonConsentCookieName = 'OptanonConsent';

const encodeProperty = (property: any) =>
  encodeURIComponent(property).replace(/[-.+*]/g, '\\$&');

/**
 * Encodes a cookie name if necessary.
 *
 * @param cookieName - The name to encode.
 * @param encoded - Whether the name is already encoded. Defaults to `true`.
 * @returns The encoded cookie name.
 */
function handleCookieName(cookieName: string, encoded: boolean): string {
  return encoded ? encodeProperty(cookieName) : cookieName;
}

export const getCookie = (cookieName: any, encoded = true) => {
  const { cookie = '' } = document;
  // From https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie/Simple_document.cookie_framework
  // the craft routing stuff references the "gnb_locale" cookie, that will be our cookie-source of language truth
  const handledCookieName = handleCookieName(cookieName, encoded);
  const contentLanguage =
    decodeURIComponent(
      cookie.replace(
        new RegExp(
          `(?:(?:^|.*;)\\s*${handledCookieName}\\s*\\=\\s*([^;]*).*$)|^.*$`
        ),
        '$1'
      )
    ) || '';

  const cookieContent =
    Array.isArray(contentLanguage) && contentLanguage.includes(',')
      ? contentLanguage.split(',')[0]
      : contentLanguage;

  return cookieContent;
};

export function getOptanonConsentObjectValues(): any {
  const optanonConsentCookieValue = getCookie(optanonConsentCookieName);
  const optanonConsent = optanonConsentCookieValue
    ? `urn:onetrust:${optanonConsentCookieValue}`
    : undefined;
  const consentIdRegex = /consentId=(\S{36})/;
  const consentIdMatch = consentIdRegex.exec(optanonConsent || '');
  const consentIdCookiePropertyValue = consentIdMatch?.[1];
  const zeroedUUID = '00000000-0000-0000-0000-000000000000';
  const optanonConsentId = consentIdCookiePropertyValue || zeroedUUID;
  const groupsIdRegex = /groups=([^&]+)/;
  const groupsIdMatch = groupsIdRegex.exec(optanonConsent || '');
  const groupsIdCookiePropertyValue = groupsIdMatch?.[1];

  return {
    optanonConsentId: optanonConsentId,
    optanonConsent: optanonConsent,
    groupsId: groupsIdCookiePropertyValue,
  };
}

export function getAnalyticsIsAllowed(): any {
  let OptGroups = (window as any)._O?.getOptInGroups();

  if (!OptGroups || OptGroups === '') {
    OptGroups = getOptanonConsentObjectValues().groupsId;
  }

  const consents = OptGroups?.split(',') || []; // returns ['1:1', '2:1', '3:1']
  const consentObj = consents.reduce(
    (accum: { [x: string]: any }, current: string) => {
      const arr = current.split(':');
      accum[arr[0] as keyof {}] = arr[1] as never;
      return accum;
    },
    {
      1: null,
      2: null,
      3: null,
    }
  );

  // Performance & Analytics Cookies
  const isAnalyticsAllowed = !!Number(consentObj['2']);

  return isAnalyticsAllowed;
}

export function validateUserAccess(): boolean {
  const isOrderOrCheckoutRoute = () => {
    const authenticatedRoutes = [
      '/order',
      '/checkout',
      '/subscription-revision',
    ];
    const path = window.location.pathname;
    return authenticatedRoutes.some((route) => path.includes(route));
  };

  if (isOrderOrCheckoutRoute()) {
    return sessionStorage.getItem(SESSION_STATUS_KEY) === 'authenticated';
  }

  return true;
}
